import React from "react";
import { Link } from "@reach/router";
import mySvg from "./larva.png";
import FormError from "./FormError";


class Home extends React.Component {
  render() {
    const { user, logOutUser } = this.props;

    const biggerLead = {
      fontSize: 1.4 + "em",
      fontWeight: 200,
    };

    return (
      <div className="text-center">
        <div className="row justify-content-center">
          <div className="col-10">
            <div
              className="display-4 text-primary mt-3 mb-2"
              style={{
                fontSize: 3 + "em",
              }}
            >
              <img src={mySvg} width="100" height="100" alt="bee-logo" />
              <br />
              Larva Species Classification
            </div>

            {/* <br/>
<FormError theMessage={"Due to Hurricane Ian, our servers are shut down for safety reasons. They will be back up early next week. Please excuse the inconvenience."} />
<br/> */}

            <p className="lead" style={biggerLead}>
              Identifies whether specimen is
              <b>
                {" "}
                <i>Anopheles stephensi</i>
              </b>{" "}
              or{" "}
              <b>
                not 
              </b>
              {" "}
              <br/>
              <br/>

              <u>Note</u>: the current AI model was trained on photos of <i>Anopheles stephensi</i>, <i>Anopheles gambiae</i>, <i>Anopheles arabiensis</i>  and <i>Anopheles funestus</i> in 3rd and 4th instars, using a smartphone with a 60X clip-on lens. Results should be considered less reliable if photos of any other species or instar, or from any other device (e.g., microscope) are uploaded.

            </p>
            <p className="lead" style={biggerLead}>
              You can upload up to 5 images and perform species classification
              on them.
            </p>
            {user && (
              <p className="row justify-content-center display-7 text-secondary">
                Go to the image upload page
              </p>
            )}
            {/*check if user is null, then do switch*/}
            {user == null && (
              <span>
                <Link to="/register" className="btn btn-outline-primary mr-2">
                  Register
                </Link>
                <Link to="/login" className="btn btn-outline-primary mr-2">
                  Login
                </Link>
              </span>
            )}
            {user && (
              <Link to="/uploadimages" className="btn btn-primary">
                Upload images
              </Link>
            )}

            <br />
            <br />

            {user && (
              <Link
                to="/"
                className="btn btn-secondary"
                onClick={(e) => logOutUser(e)}
              >
                Logout
              </Link>
            )}
          </div>
        </div>
      </div>
    );
  }
}
export default Home;
